import { BaseLayoutFactory } from "../global/base-layout-factory";
import { HomeProvider } from "./context/home-context";
import { HomeComponent } from "./home-component";


export function HomeFactory() {
    return (
        <BaseLayoutFactory>
            <HomeProvider>
                <HomeComponent />
            </HomeProvider>
        </BaseLayoutFactory>
    );
}